<template>
  <div class="mt-2">
    <b-row md="12">
      <b-col md="5">
          <span class="font-weight-bold">{{ jobQuestion.label }}: </span>
      </b-col>
      <b-col md="7">  {{ value }}</b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'RecruiterIcoCriteriaResultLocation',
  props: {
    jobQuestion: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      required: true,
    },
  },
  computed: {
    value: function () {
      return this.jobQuestion.value &&
        this.jobQuestion.value.location_zip_code
        ? this.jobQuestion.value.location_zip_code
        : '';
    },
  },
};
</script>

<style scoped />
